import React from "react";
import { Redirect, Route } from "react-router";
import { IUser } from "../components/BB8AuthPanel";

const PrivateRoute = ({
  component: Component,
  isLoggedIn,
  user,
  ...rest
}: {
  component: any;
  isLoggedIn: boolean;
  user: IUser;
}) => {
  const WrappedComponent = (props: any) =>
    isLoggedIn && props.location.pathname !== "/auth" ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: isLoggedIn && props.location.pathname === "/auth" ? "/" : "/auth",
          state: { from: props.location }
        }}
      />
    );

  return <Route {...rest} render={WrappedComponent} />;
};

export default PrivateRoute;
